module.exports = __webpack_public_path__ + "static/img/b5-4.62c4e80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b5-4.png
// module id = 1POS
// module chunks = 1